import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromEvents from '../reducers/events.reducer';
import { Event } from '../../models';
import * as fromRoot from '../../../store';

export const getEventState = createSelector(fromFeature.getContentState, (state: fromFeature.ContentState) => state.events);

export const getEventEntities = createSelector(getEventState, fromEvents.getEventsEntities);
export const getEventsLoaded = createSelector(getEventState, fromEvents.getEventsLoaded);
export const getEventsLoading = createSelector(getEventState, fromEvents.getEventsLoading);

export const getEventsOverviewEntities = createSelector(getEventState, fromEvents.getEventsOverviewEntities);
export const getEventsOverviewLoaded = createSelector(getEventState, fromEvents.getEventsOverviewLoaded);
export const getEventsOverviewLoading = createSelector(getEventState, fromEvents.getEventsOverviewLoading);

export const getAllEvents = createSelector(getEventEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getOrderedEvents = createSelector(getAllEvents, (Pages: Event[]) => {
  const orderedPages = Pages.sort((a, b) => (new Date(b.publishDate) < new Date(a.publishDate) ? 1 : -1));
  return orderedPages;
});

export const getSelectedEvent = createSelector(getEventsOverviewEntities, fromRoot.getRouterState, (entities, router): Event => {
  return router.state && entities[router.state.params?.['pageId'] || router.state.data?.['pageId']];
});
